import React from 'react';
import './Skills.css';

import { Button, Heading } from '../../../components';
import { skills } from '../../../constants';

import { FaArrowRight } from 'react-icons/fa';



const Skills = () => {

  return (
    <section className="custom-form home-skills">
      <div className="box-container">
        <div className="content">
          <div className="text">

            {/* Section Heading */}
            <Heading title={skills.heading} subTitle={skills.sub} sideHeading linear />

            <p>{skills.content}</p>

            {/* Key Skills */}
            <div className="skills">
              {skills.points.map((point) => (
                <div className="box" key={point.id}>
                  <h3>
                    {point.title}
                    <span> {point.progress}% </span>
                  </h3>
                  <div className="progress-bar">
                    <span style={{ width: `${point.progress}%` }}></span>
                  </div>
                </div>
              ))}
            </div>

            <Button link={"Contact-us"} title={"Contact Us"} icon={FaArrowRight} />

          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;